@if (description) {
  <div class="container-fluid">
    <div class="description" [innerHTML]="description | sanitizeContentfulHTML"></div>
  </div>
}
